import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import * as ReactDOMClient from 'react-dom/client';
import App from './app';
import './index.css';
var root = ReactDOMClient.createRoot(document.getElementById('root'));
root.render(React.createElement(Router, null,
    React.createElement(App, null)));
